export default __webpack_public_path__ + "static/media/CRYSTL.e9fae5f7.png";